export enum OptionId {
    MAGENTA_EINS_PREPAID = 4005,
    MAGENTA_EINS_POSTPAID = 4002,
    MAGENTA_EINS_BUSINESS = 4006,
    ADDITIONAL_PHONE_NUMBER = 1207,
    MAGENTA_TV_STICK = 5016,
    MAGENTA_TV_SMART_REGIO = 5025,
    DISNEY_PLUS = 5018,
    NONE = 5017,
}
